import { render, staticRenderFns } from "./XTextarea.vue?vue&type=template&id=0fda44a0&scoped=true&"
import script from "./XTextarea.vue?vue&type=script&lang=js&"
export * from "./XTextarea.vue?vue&type=script&lang=js&"
import style0 from "./XTextarea.vue?vue&type=style&index=0&id=0fda44a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../backend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda44a0",
  null
  
)

export default component.exports